<template>
  <div class="main">

    <tk-header-view class="header" :id="tkid"></tk-header-view>

    <v-container fluid class="search">
      <v-layout column>

        <!-- <b>TK Name: {{ profileinfo.tkname }}</b> -->

       <v-card flat color="transparent" elevation-24>
         <!-- Inner Cards for further details -->
          <v-container fluid grid-list-md>

            <v-layout row wrap>
              <v-flex xs12>
                <v-card flat color="transparent">
                  <v-card-text>
                    <p><span class="tkheading">Timmy's Kitty's</span> is still in development. Videos of <span class="tk-name">{{ profileinfo.tkname }}</span> are soon to come. Like us on <a href="https://www.facebook.com/timmyskittys1" target="_blank" style="text-decoration: none; color: blue;">FaceBook</a> for current photos and videos, and updates for this site. Also, please see the TK <b>About</b> for more info on us. Thanks for visiting, we appreciate your time, and hope you'll visit us again.</p>
                  </v-card-text>
                  </v-card>
                </v-flex>
                </v-layout>

            <v-layout row wrap justify-center align-center>
              <v-flex xs12 sm4>
                <v-card color="blue mb-2 card-frame" class="black--text" hover elevation-24>
                  <v-layout>
                    <v-flex class="ma-2">
                      <v-img class="card-frame" :src="require(`@/img/${profileinfo.profilepict}`)"></v-img>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

          </v-container>
        </v-card>

      </v-layout>
    </v-container>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import TkHeaderView from "./TkHeaderView";
import FooterView from "./FooterView";

export default {
  components: {
    TkHeaderView,
    FooterView
  },
  props: {
    tkid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    show: true,
    title: "",
    logo: "sebastian_logo_layer_at_1440x1105.png",
  }),
  methods: {
    goHome() {
      this.$router.go({
        path: "/",
        force: true
      });
    }
  },
  computed: {
    ...mapGetters([
      'getById'
    ]),
    profileinfo () {
      return this.getById(this.tkid)
    }
  },
};
</script>

<style scoped>
.main {
  background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 100%;
  height: 100%;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2.5rem;
}
.card-frame {
  border-radius: 4px;
}
.tkheading {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 1.8rem;
  line-height: 0;
  font-weight: bolder;
  color: blue;
  margin-right: 3px;
}
.tk-name {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 1.2rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  line-height: 0;
  font-weight: bolder;
  color: blue;
 /* text-transform: capitalize; */
  /* color: black; */
  /* font-size: 2rem; */
  /* line-height: 0; */
  /* text-shadow: -2px 2px 3px rgba(0, 0, 0, .3); */
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.footer {
  margin-top: 0;
}
/* iPhone 6, 7, 8 ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 60px;
  }
}
/* iPhone 6+, 7+, 8+ ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 60px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 60px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 60px;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 60px;
  }
}
/* Samsung Galaxy S3 ----------- */
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TkVideosView.vue